import { z } from "zod";

import { temporalDataPointSchema } from "@/components/ui/chart/types/temporal-chart-series.type";
import { EMainConsumptionSource } from "@/data/api/kili/consumption/types/common-consumption.type";

export const heatmapConsumptionSchema = z.object({
  heatmap: z.array(temporalDataPointSchema),
  source: z.nativeEnum(EMainConsumptionSource),
});

export type THeatmapConsumption = z.infer<typeof heatmapConsumptionSchema>;
